import { ColumnDef } from "@tanstack/table-core";
import { Link } from "react-router-dom";
import {OrderAheadItem} from "../../../../types/orderAhead";
import {usePermissions} from "../../../auth/api";
import {Item} from "../orderAheadOrder";
import {capitalize} from "lodash";
import {usdFormat} from "../../../../utils";
import Table from "../../../../components/Table";

export const ItemsTable = ({ items }: { items: OrderAheadItem[] }) => {
  const { editCreatePermission: itemsEditPermission } = usePermissions("items");
  const itemsColumns: ColumnDef<Item>[] = [
    {
      header: "Name",
      accessorKey: "name",
      cell: (info) => (
        <>
          {itemsEditPermission ? (
            <Link to={`/items/${info.row.original.id}`}>
              {capitalize(info.getValue<string>())}
            </Link>
          ) : (
            <>{capitalize(info.getValue<string>())}</>
          )}
        </>
      ),
    },
    {
      header: "Price",
      accessorKey: "price",
      cell: (info) => usdFormat.format(info.getValue<number>() / 100),
    },
    {
      header: "Quantity",
      accessorKey: "quantity",
    },
    {
      header: "Total",
      accessorKey: "price",
      cell: (info) =>
        usdFormat.format(
          (info.getValue<number>() / 100) * (info.row.original.quantity ?? 1)
        ),
    },
  ];
  // Create an array of unique items by itemId
  const uniqueItems = items.reduce((acc, item) => {
    const existingItem = acc.find((i) => i.id === item.id);
    if (existingItem) {
      existingItem.quantity = (existingItem.quantity ?? 1) + 1;
    } else {
      acc.push({
        ...item,
        quantity: 1,
      });
    }
    return acc;
  }, [] as OrderAheadItem[]);

  return <Table columns={itemsColumns} data={uniqueItems} />;
};
